module.exports = __webpack_public_path__ + "static/media/verein-statut-17012007.c89b3fdc.pdf";